module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=HU - Hungary.d89b97f6.svg";